import React from 'react';
import { withRouter } from 'react-router-dom';
import VisuelChoixVisualiseurStylisteCuisine from "../visuels/Ecrans bornes/ECRANS accueil ET cuisine/Ecrans bornes CUISINE V3-page-003.jpg";
import VisuelChoixVisualiseurStylisteSdb from "../visuels/Ecrans bornes/ECRANS accueil ET cuisine/Ecrans bornes SDB V3-page-003.jpg";

class ChoixStylisteVisualiseur extends React.Component {

    redirectToHome = () => {
        const { history } = this.props;
        if(history) history.push('/');
    }

    redirectToVisualiseur = () => {
        const { history,match } = this.props;
        var piece = match.params.piece;
        if(history)
        {
            history.push('/pieces/' + piece + '/visualiseur');
        }
    }
    redirectToStyliste = () => {
        const { history,match } = this.props;
        var piece = match.params.piece;
        if(history)
        {
            history.push('/pieces/' + piece + '/styliste');
        }
    }

    redirectToInfo = () => {
        const { history } = this.props;
        if(history) history.push('/infos');
    }
    redirectToBack = () => {
        const { history } = this.props;
        if(history) history.goBack();
    }

    pageAAfficher(piece)
    {
        console.log(piece);
        if(piece === "sdb")
        {
            this.visuel = VisuelChoixVisualiseurStylisteSdb;
        }
        if(piece === "cuisine")
        {
            this.visuel = VisuelChoixVisualiseurStylisteCuisine;
        }
    }

    render() {
        const { history,match,piece } = this.props;
        const { params } = this.props.match;
        this.piece = params.piece;
        this.pageAAfficher(this.piece);
        return  (
            <div>
                <img src={this.visuel} alt="Visualiseur ou choix des harmonies du styliste" style={{width:1280}} useMap="#image-map"/>

                <map name="image-map">

                    <area onClick={this.redirectToVisualiseur} alt="" title="Visualiseur"   coords=" 0,1200,630,0" shape="rect"/>
                    <area onClick={ this.redirectToStyliste} alt="" title="Styliste"  coords="1400,900,650,-1" shape="rect"/>
                    <area onClick={ this.redirectToHome} alt="" title="Home" coords="1000,1200,890,900" shape="rect"/>
                    <area onClick={ this.redirectToBack} alt="" title="Back" coords="1150,1200,1005,900" shape="rect"/>
                    <area onClick={this.redirectToInfo} alt="" title="Infos" coords="1100,1200,1250,900" shape="rect"/>
                </map>
            </div>);
    }

}

export default withRouter(ChoixStylisteVisualiseur);